@if (tabs) {
  <app-tabs
    [tabs]="tabs">
  </app-tabs>
}

<br>

  <app-data-grid
    [data]="gridData$ | async"
    [loading]="isLoading"
    [filterable]="true"
    [filter]="filter"
    (filterChange)="filterChange($event)"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip"
    (pageChange)="pageChange($event)"
    [height]="700">
    <app-data-grid-column
      field="name"
      title="{{ 'name' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>

    <app-data-grid-column
      field="device_type"
      title="{{ 'deviceType' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="app_version"
      title="{{ 'appVersion' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="serial_number"
      title="{{ 'serialNumber' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="office_group"
      title="{{ 'officeGroup' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>

    @if (authService.isBasicSupportUser) {
      <app-data-grid-command-column>
        <ng-template appGridCellTemplate let-dataItem>
          @if (dataItem?.claimed) {
            <button
              class="dg-btn dg-btn--primary"
              (click)="unlink(dataItem)">
              {{ 'unlink' | translate | titlecase }}
            </button>
          }
        </ng-template>
      </app-data-grid-command-column>
    }
  </app-data-grid>
